import { SvgIcon, SvgIconProps } from "@mui/material";

export default ({
  color,
  ...props
}: Omit<SvgIconProps, "color"> & { color?: string }) => (
  <SvgIcon
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    stroke={props.fill}
    {...props}
  >
    <path
      fill={color}
      d="M332-340h54l30-82h128l30 82h56L508-660h-56L332-340Zm100-128 46-132h4l46 132h-96Zm48 388q-83 0-156-31"
    />
    <path
      fill={color}
      d="M440-800v-120h80v120h-80Zm0 760v-120h80v120h-80Zm360-400v-80h120v80H800Zm-760 0v-80h120v80H40Zm708-252-56-56 70-72 58 58-72 70ZM198-140l-58-58 72-70 56 56-70 72Zm564 0-70-72 56-56 72 70-58 58ZM212-692l-72-70 58-58 70 72-56 58Z"
    />

    <circle
      cx="480"
      cy="-480"
      r="280"
      fill="none"
      stroke={color}
      strokeWidth="40"
    />
  </SvgIcon>
);
